import { objectWithoutProperties as _objectWithoutProperties } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import _styled from '@emotion/styled/base';
import 'react';
import { ImageMapLinkEditor } from '../ImageMapLink/ImageMapLinkEditor/ImageMapLinkEditor.js';
import { ImageMapShareButton } from './ImageMapShareButton.js';
import { jsx } from '@emotion/react';

var _excluded = ["children", "path"];
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
function ImageMapShare(_ref) {
  var children = _ref.children,
    path = _ref.path,
    rest = _objectWithoutProperties(_ref, _excluded);
  return jsx(ImageMapLinkEditor, {
    path: path
  }, jsx(StyledButton, rest, children || ''));
}
var StyledButton = /*#__PURE__*/_styled(ImageMapShareButton, process.env.NODE_ENV === "production" ? {
  target: "evhkvfs0"
} : {
  target: "evhkvfs0",
  label: "StyledButton"
})(process.env.NODE_ENV === "production" ? {
  name: "a4hmbt",
  styles: "position:absolute"
} : {
  name: "a4hmbt",
  styles: "position:absolute",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkltYWdlTWFwU2hhcmUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCZ0QiLCJmaWxlIjoiSW1hZ2VNYXBTaGFyZS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSAncmVhY3QnO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbXBvcnQgeyBEb2N1bWVudFBhdGggfSBmcm9tICcuLi8uLi8uLi90eXBlcyc7XG5pbXBvcnQgeyBJbWFnZU1hcExpbmtFZGl0b3IgfSBmcm9tICcuLi9JbWFnZU1hcExpbmsvSW1hZ2VNYXBMaW5rRWRpdG9yJztcbmltcG9ydCB7IEltYWdlTWFwU2hhcmVCdXR0b24sIEltYWdlTWFwU2hhcmVCdXR0b25Qcm9wcyB9IGZyb20gJy4vSW1hZ2VNYXBTaGFyZUJ1dHRvbic7XG5cbmV4cG9ydCBpbnRlcmZhY2UgSW1hZ2VNYXBTaGFyZVByb3BzIGV4dGVuZHMgSW1hZ2VNYXBTaGFyZUJ1dHRvblByb3BzIHtcbiAgcGF0aDogRG9jdW1lbnRQYXRoO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gSW1hZ2VNYXBTaGFyZSh7XG4gIGNoaWxkcmVuLFxuICBwYXRoLFxuICAuLi5yZXN0XG59OiBSZWFjdC5Qcm9wc1dpdGhDaGlsZHJlbjxJbWFnZU1hcFNoYXJlUHJvcHM+KSB7XG4gIHJldHVybiAoXG4gICAgPEltYWdlTWFwTGlua0VkaXRvciBwYXRoPXtwYXRofT5cbiAgICAgIDxTdHlsZWRCdXR0b24gey4uLnJlc3R9PlxuICAgICAgICB7IGNoaWxkcmVuIHx8ICcnIH1cbiAgICAgIDwvU3R5bGVkQnV0dG9uPlxuICAgIDwvSW1hZ2VNYXBMaW5rRWRpdG9yPlxuICApO1xufVxuXG5jb25zdCBTdHlsZWRCdXR0b24gPSBzdHlsZWQoSW1hZ2VNYXBTaGFyZUJ1dHRvbilgXG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbmA7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { ImageMapShare };
//# sourceMappingURL=ImageMapShare.js.map
